
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Style from "../../css/screens/Login.module.scss";
import { loginAction } from "../../redux/auth/login";
import { app } from "../../services/firebase";
import QuizWallIcon from "../../assets/svg/QuizWallicon";
import MaleLoginIcon from "../../assets/svg/MaleLoginIcon";
import GoogleLogo from "../../assets/svg/GoogleLogo";
import LoadingSpinner from "../user/theme6/component/LoadingSpinner"
export default function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let { search } = useLocation();
  const query = new URLSearchParams(search);
  const provider = new GoogleAuthProvider();
  const isAuthenticatedAppId = JSON.parse(localStorage.getItem("pwa_app_id"));

  // Helper function to safely get from localStorage
  const getFromStorage = (key) => {
    try {
      const item = localStorage.getItem(key);
      return item && item !== "undefined" && item !== "null" ? JSON.parse(item) : null;
    } catch {
      return null;
    }
  };

  // Helper function to safely set to localStorage
  const setToStorage = (key, value) => {
    if (value !== null && value !== undefined) {
      localStorage.setItem(key, JSON.stringify(value));
    }
  };

  // Get values
  const app_id = query.get("app_id") || getFromStorage("pwa_app_id");
  const platform = query.get("platform") || getFromStorage("pwa_platfrom");
  const pwa_reward_user_id = query.get("user_id") || getFromStorage("pwa_user_id");
  const email = query.get("email") || getFromStorage("email");
  const name = query.get("name") || getFromStorage("name");
  const mobile = query.get("mobile") || getFromStorage("mobile");
  const mission_id = query.get("mission_id");

  // Store values (only if they exist)
  setToStorage("pwa_platfrom", platform);
  setToStorage("pwa_app_id", app_id);
  setToStorage("pwa_user_id", pwa_reward_user_id);
  setToStorage("email", email);
  setToStorage("name", name);
  setToStorage("mobile", mobile);
  setToStorage("mission_id", mission_id);
  const request = window.indexedDB.open("pwa_db", 1);

  request.onerror = () => { };

  request.onupgradeneeded = (event) => {
    const db = event.target.result;
    db.createObjectStore("platform", { keyPath: platform });
  };


  const [locationSnack, setLocationSnack] = useState(false);
  const [location, setLocation] = useState({});
  const [backDrop, setBackDrop] = useState(false);
  const [locationAccess, setLocationAccess] = useState(false);
  const [load, setLoad] = useState(false);
  const theme = localStorage.getItem('pwa_app_theme')

  // fn

  const handleGoogleLogin = async () => {
    setLoad(true)
    try {


      const auth = getAuth(app);
      const response = await signInWithPopup(auth, provider);
      const user = response?.user;
      const { email, displayName, phoneNumber } = user;
      const loginData = await dispatch(
        loginAction({
          app_id: null,
          user_id: null,
          platform: "Web",
          name: displayName,
          email: email,
          mobile: null,
        })
      );

      if (loginData?.payload?.status == 200) {
        localStorage.setItem(
          "pwa_publisher_id",
          JSON.stringify(loginData?.payload?.data?.publisher_id)
        );
        localStorage.setItem(
          "pwa_platfrom",
          JSON.stringify(loginData?.payload?.data?.platform)
        );
        localStorage.setItem(
          "pwa_app_id",
          JSON.stringify(loginData?.payload?.app_id)
        );
        localStorage.setItem(
          "pwa_user_id",
          JSON.stringify(loginData?.payload?._id)
        );
        localStorage.setItem(
          "pwa_token",
          JSON.stringify(loginData?.payload?.token)
        );
        localStorage.setItem(
          "pwa_app_theme",
          JSON.stringify(loginData?.payload?.theme)
        );

        localStorage.setItem("pwa_app_scroll", JSON.stringify(true));
        localStorage.setItem("reload", JSON.stringify(true));

        setLoad(false);

        // console.log(dispatch(getUserDetailsAction()))

        const redirectPath = loginData?.payload?.is_new ? "/avatar" : "/home-challenge";
        window.location.href = redirectPath;


        // console.log("login Done")
      }
    } catch (err) {
      setLoad(false)

    } finally {
      setLoad(false)
    }


  };

  const handleLogin = async () => {
    setLoad(true);
    setBackDrop(true);
    try {
      const loginData = await dispatch(
        loginAction({
          // publisher_id: publisher_id,
          app_id: app_id || JSON.parse(localStorage.getItem("pwa_app_id")),
          user_id:
            pwa_reward_user_id ||
            JSON.parse(localStorage.getItem("pwa_user_id")),
          platform:
            platform || JSON.parse(localStorage.getItem("pwa_platfrom")),
          name: name || JSON.parse(localStorage.getItem("name")),
          email: email || JSON.parse(localStorage.getItem("email")),
          mobile: mobile || JSON.parse(localStorage.getItem("mobile")),
        })
      );

      if (loginData?.payload?.status == 200) {
        localStorage.setItem(
          "pwa_token",
          JSON.stringify(loginData?.payload?.token)
        );
        localStorage.setItem(
          "pwa_app_theme",
          JSON.stringify(loginData?.payload?.theme)
        );
        localStorage.setItem("pwa_app_scroll", JSON.stringify(true));
        localStorage.setItem("reload", JSON.stringify(true));
        localStorage.setItem("is_default", JSON.stringify(loginData?.payload?.isDefault));
        if(loginData?.payload?.theme == 6){
                window.location.href = "/avatar";

        }else{
                          window.location.href = "/home";


        }
                                  await new Promise((resolve) => setTimeout(resolve, 3000));


      }
      setBackDrop(false);
    } catch (error) {
      console.log("error");
    } finally {
      setLoad(false);
    }
  };

  // location given or not
  navigator.permissions
    .query({ name: "geolocation" })
    .then((permissionStatus) => {
      permissionStatus.onchange = () => {
        setBackDrop(true);
        if (permissionStatus.state == "granted") {
          setLocationAccess(true);
        } else {
          setLocationAccess(false);
          setBackDrop(false);
          setLocationSnack(true);
        }
      };
    });

  const locationSuccessCallback = async (position) => {
    if (position?.coords?.latitude && position?.coords?.longitude) {
      setLocation({
        lat: position?.coords?.latitude,
        long: position?.coords?.longitude,
      });
      setBackDrop(false);
    }
  };

  const locationErrorCallback = (error) => {
    if (error?.GeolocationPositionError?.code == 1) {
      setLocation({});
    }
  };

  let userLocation = async () => {
    navigator.geolocation.getCurrentPosition(
      locationSuccessCallback,
      locationErrorCallback
    );
  };

  // use effect
  // get location
  useEffect(() => {
    userLocation();
  }, []);

  useEffect(() => {
    if (app_id?.length > 10) {
      handleLogin();
    }

  }, [app_id]);

  useEffect(() => {
    if (Object?.keys(location)?.length) {
      setLocationAccess(true);
    }
  }, [location]);

  useEffect(() => {

    if (isAuthenticatedAppId) {
      if (JSON.parse(theme) == 6) {
        navigate("/home-challenge");
      }
      else {
        // localStorage.clear();
        navigate("/", { replace: true });
      }
    }

  }, []);

  return (
    <>
      {load && <LoadingSpinner />}
      <div className={Style.login_container}>
        <div className={Style.login_box1}>
          <QuizWallIcon
            width="100%"
            height="auto"
            style={{ maxWidth: '162px' }}
          />
        </div>
        <div className={Style.login_box2}>
          <p className={Style.login_text1}>Welcome</p>
          <p className={Style.login_text1}>to Quizwall</p>
        </div>
        <div className={Style.login_box3}>
          <div className={Style.login_box_image}>
            <MaleLoginIcon
              width={231}
              height={251}

            />
          </div>
        </div>
        <div className={Style.login_box_wrapper}>
          <div className={Style.login_box4}>
            <div className={Style.login_box4_bg} />
            <div className={Style.login_box4_content}>
              <p className={Style.login_text2}>Login/Signup</p>
              <p className={Style.login_text3}>Continue to get started</p>
              <div className={Style.login_Box8}>
                <GoogleLogo width={30} height={30} />

                <p
                  className={Style.login_text4}
                  onClick={() => handleGoogleLogin()}
                >
                  Continue with Google
                </p>
              </div>
            </div>
            <div className={Style.login_box4_bg_bottom} />
          </div>
        </div>

        <div className={Style.login_box5}>
          <p className={Style.login_text6}>
            By continuing to Quizwall you agree to all
          </p>
          <p className={Style.login_text7}>
            <span onClick={() => window.open('https://publisher.quizwall.io/term-of-use', '_blank')}>
              T and C,{" "}
            </span>
            <span
              onClick={() => window.open('https://publisher.quizwall.io/privacy', '_blank')}
            >
              Privacy Policy
            </span>
          </p>
        </div>
      </div>
    </>
  );
}
